import { DragOverlay, defaultDropAnimationSideEffects, type UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type React from 'react';
import type { HTMLAttributes } from 'react';
import { createPortal } from 'react-dom';

type Props = HTMLAttributes<HTMLDivElement> & {
  id: UniqueIdentifier;
  isHandle?: boolean;
  disabled?: boolean;
  isOverlay?: boolean;
};

// NOTE: Drag 핸들이 특정 컴포넌트로될 경우, Nested Dnd의 부모의 Drag 이벤트가 발생하는 것을 방지하기 위해 추가
const notHandleListeners = {
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
    e.stopPropagation();
  },
  onPointerDown: (e: React.PointerEvent<HTMLDivElement>) => {
    e.stopPropagation();
  },
};

export const Draggable = ({
  id,
  isHandle = true,
  disabled = false,
  isOverlay = true,
  ...props
}: Props) => {
  const { attributes, listeners, setNodeRef, transition, transform, isDragging } = useSortable({
    id,
    disabled,
  });

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
    opacity: isDragging ? 0.5 : undefined,
    ...props.style,
  };

  return (
    <>
      <div
        {...props}
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...(isHandle ? listeners : notHandleListeners)}
      >
        {props.children}
      </div>
      {isOverlay &&
        isDragging &&
        createPortal(
          <DragOverlay
            adjustScale={false}
            dropAnimation={{
              sideEffects: defaultDropAnimationSideEffects({
                styles: {
                  active: {
                    opacity: '0.5',
                  },
                },
              }),
            }}
          >
            <div {...props}>{props.children}</div>
          </DragOverlay>,
          document.body,
        )}
    </>
  );
};
